import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@ieCore/services/auth.service';
import { inject } from '@angular/core';
import { NavService } from '@ieCore/services/nav.service';
import { RETURN_URL_PARAM } from '@ieCore/utils/return-url.utils';
import logger from '@ieShared/utils/logger.utils';

export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const navService = inject(NavService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    // Carry the attempted URL (path + query string + fragment) so login can send
    // the user back to it. It is validated on consume, never on capture.
    router
      .navigate(navService.to.login(), {
        queryParams: { [RETURN_URL_PARAM]: state.url },
      })
      .then(() => logger.log('Navigated to login page'));

    return false;
  }

  return true;
};
